// extracted by mini-css-extract-plugin
var _1 = "CalendarRailBlock-moduleCalendarRailBlock__wwqIy";
export { _1 as "CalendarRailBlock" }
